import React from 'react';
import MainParagraph from "../../common_components/main_paragraph/main_paragraph";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import LuissButton from "../../common_components/luiss_button/luiss_button";
import "./img_paragraph_cta.scss";

class ImgParagraphCta extends TemplateComponent<any, any> {

    componentRender(data: any): React.ReactElement<any> {
        return (
            <div className="img-paragraph-cta">
                <MainParagraph title={data.title} text={data.text} />
                <img src={data.image} alt={data.title + " image"}/>
                <LuissButton url={data.url}>{data.cta}</LuissButton>
            </div>
        );
    }
}

export default ImgParagraphCta;